import type { ReactNode } from "react";

export function Stat({
  value,
  label,
  accent = "text-ink-900",
  icon,
}: {
  value: ReactNode;
  label: string;
  accent?: string;
  icon?: ReactNode;
}) {
  return (
    <div className="stat-tile">
      <div className="flex items-start justify-between">
        <div>
          <div className={`text-3xl font-semibold ${accent}`}>{value}</div>
          <div className="text-sm text-ink-500 mt-1">{label}</div>
        </div>
        {icon && <div className="text-ink-300">{icon}</div>}
      </div>
    </div>
  );
}
